import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

/**
 * Must match ACTIVE_LOCATION in functions/dataLocation.js.
 * Change to "london" only on UK migration night (see scripts/uk-migration/README.md).
 */
const ACTIVE_LOCATION = "us";

const LOCATIONS = {
  us: { functionsRegion: "us-central1", storageBucket: "smileconsent-1b9b2.firebasestorage.app" },
  london: { functionsRegion: "europe-west2", storageBucket: "smileconsent-1b9b2-london" },
};

const location = LOCATIONS[ACTIVE_LOCATION];

export const firebaseConfig = {
  apiKey: "AIzaSyB4KPNoYMVIrMM-umEthTMQuwi5NrYi6PU",
  authDomain: "smileconsent-1b9b2.firebaseapp.com",
  projectId: "smileconsent-1b9b2",
  storageBucket: location.storageBucket,
  messagingSenderId: "322808961158",
  appId: "1:322808961158:web:1cad16240e38ab72349907",
  measurementId: "G-4XDVDECE2Z"
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
// Always use deployed Cloud Functions. Local Functions emulator
// is opt-in via a separate config if needed — auto-connecting broke callables
// whenever the emulator was not running (504 / ECONNREFUSED).
const functions = getFunctions(app, location.functionsRegion);

export { app, auth, db, storage, functions };
